import { MenuItem } from '../../../../shared/framework/navigation/models/MenuItem';
import { HomeWidgets } from './HomeWidgets';
import { IWidgetSection } from './IWidgetSection';


export class WidgetSection {
    constructor(section: IWidgetSection) {
        this.id = section.id;
        this.angularComponent = section.angularComponent;
        this.sortOrder = section.sortOrder;
        this.isCollapsed = section.isCollapsed;
        this.showIfEmpty = section.showIfEmpty;
        this.showAddIfEmpty = section.showAddIfEmpty;
        this.numberOfItemsToShow = section.numberOfItemsToShow;
        this.collapsed = section.collapsed;
        this.showGraph = section.showGraph;
        this.hideWidget = section.hideWidget;
        this.menuItemId = section.menuItemId;
        this.menuItem = new MenuItem(section.menuItem);
        this.component = this._getComponent();
    }

    id: number;
    menuItemId: number;
    sortOrder: number;
    isCollapsed: boolean;
    menuItem: MenuItem;
    showIfEmpty: boolean;
    showAddIfEmpty: boolean;
    numberOfItemsToShow: number;
    collapsed: boolean;
    showGraph: boolean;
    hideWidget: boolean;
    component: HomeWidgets;
    public angularComponent: string;

    private _getComponent(): HomeWidgets {
        const c: HomeWidgets = HomeWidgets[this.angularComponent];
        return c || HomeWidgets.TEMP;
    }
}
